import { Routes, Route, Navigate } from 'react-router-dom'
import { LoginPage } from './pages/LoginPage'
import { OneNoteAppPage } from './pages/OneNoteAppPage'
import { Layout } from './components/Layout'
import { TenantsPage } from './pages/TenantsPage'
import { OneDriveToolPage } from './pages/OneDriveToolPage'
import { ProjectsPage } from './pages/ProjectsPage'
import { ProjectDetailPage } from './pages/ProjectDetailPage'
import { NewProjectPage } from './pages/NewProjectPage'
import { UsersPage } from './pages/UsersPage'
import { PlanningPage } from './pages/PlanningPage'
import { ReviewApprovalPage } from './pages/ReviewApprovalPage'
import ExecutionPage from './pages/ExecutionPage'
import { useAuth } from './hooks/useAuth'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth()
  if (isLoading) return <div className="flex h-screen items-center justify-center text-slate-500">Carregando...</div>
  if (!isAuthenticated) return <Navigate to="/login" replace />
  return <>{children}</>
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* Utilitário do usuário final: sem login do produto, sem a moldura do console. */}
      <Route path="/onenote" element={<OneNoteAppPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/projects" replace />} />
        <Route path="tenants" element={<TenantsPage />} />
        <Route path="onedrive-tool" element={<OneDriveToolPage />} />
        <Route path="projects" element={<ProjectsPage />} />
        <Route path="projects/new" element={<NewProjectPage />} />
        <Route path="projects/:id" element={<ProjectDetailPage />} />
        <Route path="projects/:projectId/plan" element={<PlanningPage />} />
        <Route path="projects/:projectId/review" element={<ReviewApprovalPage />} />
        <Route path="projects/:projectId/execute" element={<ExecutionPage />} />
        <Route path="users" element={<UsersPage />} />
      </Route>
    </Routes>
  )
}
